import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/Header/Header';
import Navbar from '../../components/Navbar/Navbar';
import './HackathonSupport.css';
import OurOffices from '../../components/OurOffices/OurOffices';
import Footer from '../../components/Footer/Footer';
import heroImage from '../../assets/hackathon-hero.jpg';

const SOURCE_OPTIONS = [
  'Friend / Family Referral','School / College Recommendation','Google Search',
  'Social Media (Instagram / Facebook)','YouTube','LinkedIn','WhatsApp',
  'Newspaper / Magazine','Event / Hackathon','ibots Website','Other',
];

const PROMO_ITEMS = [
  { badge: 'FREE', text: 'Book a free consultation today — no commitment' },
  { badge: 'ON-SITE', text: 'Movable component store at your venue' },
  { badge: 'EXPERTS', text: 'Hands-on technical mentors during the event' },
];

const STATS = [
  { number: 50, label: 'HACKATHONS' },
  { number: 50, label: 'SCHOOLS' },
  { number: 25, label: 'COLLEGES' },
  { number: 5,  label: 'YEARS EXP.' },
];

const SERVICES = [
  { number:'01', title:'End-to-End Organization',
    icon:(<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2"><polyline points="9 11 12 14 22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></svg>),
    image:'https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=800&q=80',
    description:'Complete planning and execution support from the initial concept stage all the way through to prize distribution.',
    tags:['Event Planning','Scheduling','Coordination','Prize Management','Problem Statements'],
  },
  { number:'02', title:'Movable Store Support',
    icon:(<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>),
    image:'https://images.unsplash.com/photo-1518770660439-4636190af475?w=800&q=80',
    description:'On-demand components and kits delivered right to your hackathon venue. Students get immediate access to sensors, modules, microcontrollers, and more.',
    tags:['On-Site Store','Instant Access','Predefined Wide Component Range','Live Inventory'],
  },
  { number:'03', title:'Technical Mentorship',
    icon:(<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>),
    image:'https://images.unsplash.com/photo-1531482615713-2afd69097998?w=800&q=80',
    description:'On-site guidance from ibots technical experts throughout the entire hackathon.',
    tags:['Domain Mentors','Hardware Hackathon','Code Debugging','Prototype Guidance'],
  },
  { number:'04', title:'Sponsorship Management',
    icon:(<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2"><circle cx="12" cy="12" r="10"/><path d="M12 8v4l3 3"/><line x1="12" y1="6" x2="12" y2="8"/><path d="M9 12h6"/></svg>),
    image:'https://images.unsplash.com/photo-1556761175-4b46a572b786?w=800&q=80',
    description:'We identify, approach, and manage sponsor relationships for your hackathon.',
    tags:['Sponsor Outreach','Custom Packages','Brand Activation'],
  },
];

const DIFFERENCES = [
  { icon:(<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>), title:'Real-Time Problem Solving', desc:'Our on-site experts resolve hardware and software issues instantly.' },
  { icon:(<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2"><line x1="12" y1="2" x2="12" y2="6"/><line x1="12" y1="18" x2="12" y2="22"/><path d="M9 12a3 3 0 1 0 6 0 3 3 0 0 0-6 0"/><path d="M5.636 5.636l2.828 2.828M15.536 15.536l2.828 2.828M2 12h4M18 12h4M5.636 18.364l2.828-2.828M15.536 8.464l2.828-2.828"/></svg>), title:'Innovation-First Approach', desc:'We guide students to think beyond the brief and build solutions with real-world applications.' },
  { icon:(<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/></svg>), title:'Component Availability', desc:'Our movable store ensures every team has access to the right components exactly when they need them.' },
  { icon:(<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2"><circle cx="12" cy="8" r="6"/><path d="M15.477 12.89L17 22l-5-3-5 3 1.523-9.11"/></svg>), title:'Proven Track Record', desc:'Trusted by leading colleges and schools across Tamil Nadu.' },
];

const STATS_DATA = [
  { number:50, suffix:'+', label:'Hackathons Supported' },
  { number:50, suffix:'+', label:'Schools' },
  { number:25, suffix:'+', label:'Colleges' },
  { number:5,  suffix:'+', label:'Years of Experience' },
];

const GALLERY_IMAGES = [
  'https://ibots.in/wp-content/uploads/2026/03/11.png',
  'https://ibots.in/wp-content/uploads/2026/03/10.png',
  'https://ibots.in/wp-content/uploads/2026/03/9.png',
  'https://ibots.in/wp-content/uploads/2026/03/8.png',
];

const errStyle = { color:'#e8394d', fontSize:'11px', marginTop:'4px' };

function useCountUp(target, duration=1800, start=false) {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!start) { setCount(0); return; }
    let startTime = null;
    const step = (ts) => {
      if (!startTime) startTime = ts;
      const p = Math.min((ts - startTime) / duration, 1);
      setCount(Math.floor(p * target));
      if (p < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }, [target, duration, start]);
  return count;
}

function StatItem({ number, label, animate }) {
  const count = useCountUp(number, 1600, animate);
  return (
    <div className="hs-stat">
      <span className="hs-stat__number">{count}</span>
      <span className="hs-stat__label">{label}</span>
    </div>
  );
}

/* ── HERO SLIDES DATA ────────────────────────────────────────────────────── */
const HERO_SLIDES = [
  { id: 'main' },   /* existing slide */
  { id: 'spark' },  /* ibots Spark 1.0 slide */
];

function HackathonSupport() {
  const navigate = useNavigate();
  const [animateStats, setAnimateStats] = useState(false);
  const [hsSubmitted, setHsSubmitted] = useState(false);
  const [hsForm, setHsForm] = useState({
    name:'', phone:'', email:'', organization:'',
    location:'', hackathonDate:'', servicesRequired:'', message:'',
    source:'', customSource:'',
  });
  const [errors, setErrors] = useState({});
  const statsRef      = useRef(null);
  const videoRef      = useRef(null);
  const statsBannerRef= useRef(null);
  const [expandedVideo, setExpandedVideo] = useState(null);
  const [animateBanner, setAnimateBanner] = useState(false);

  /* Hero slider state */
  const [heroSlide, setHeroSlide] = useState(0);
  const [heroAnim,  setHeroAnim]  = useState(false);

  /* Auto-advance hero slider */
  useEffect(() => {
    const t = setInterval(() => {
      setHeroAnim(true);
      setTimeout(() => { setHeroSlide(s => (s + 1) % HERO_SLIDES.length); setHeroAnim(false); }, 500);
    }, 6000);
    return () => clearInterval(t);
  }, []);

  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => setAnimateStats(e.isIntersecting), { threshold:0.3 });
    if (statsRef.current) obs.observe(statsRef.current);
    return () => obs.disconnect();
  }, []);

  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => setAnimateBanner(e.isIntersecting), { threshold:0.3 });
    if (statsBannerRef.current) obs.observe(statsBannerRef.current);
    return () => obs.disconnect();
  }, []);

  function goToSlide(i) {
    setHeroAnim(true);
    setTimeout(() => { setHeroSlide(i); setHeroAnim(false); }, 400);
  }

  const handleHsSubmit = async () => {
    const newErrors = {};
    if (!hsForm.name)         newErrors.name         = 'Name is required';
    if (!hsForm.phone)        newErrors.phone        = 'Phone number is required';
    if (!hsForm.email)        newErrors.email        = 'Email is required';
    if (!hsForm.organization) newErrors.organization = 'Organization is required';
    if (!hsForm.location)     newErrors.location     = 'Location is required';
    if (!hsForm.source)       newErrors.source       = 'Please tell us how you heard about ibots';
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      setTimeout(() => { const f = document.querySelector('.error-field'); if (f) f.scrollIntoView({ behavior:'smooth', block:'center' }); }, 100);
      return;
    }
    try {
      try { await fetch('http://localhost:5000/api/enquiry', { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({ formType:'hackathon-support', fullName:hsForm.name, phone:hsForm.phone, email:hsForm.email, organization:hsForm.organization, city:hsForm.location, hackathonDate:hsForm.hackathonDate, servicesRequired:hsForm.servicesRequired, message:hsForm.message, source:hsForm.source==='Other'?hsForm.customSource:hsForm.source }) }); } catch(e){}
      try { await fetch('http://localhost:5000/api/hackathon', { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({ name:hsForm.name, phone:hsForm.phone, email:hsForm.email, organization:hsForm.organization, city:hsForm.location, hackathonDate:hsForm.hackathonDate, servicesRequired:hsForm.servicesRequired, message:hsForm.message, source:hsForm.source==='Other'?hsForm.customSource:hsForm.source, formType:'hackathon-support' }) }); } catch(e){}
      setHsSubmitted(true);
    } catch { alert('Something went wrong. Please try again.'); }
  };

  return (
    <div className="hackathon-support-page">
      <Header />
      <Navbar />

      {/* Promo bar */}
      <div className="hs-promo-bar">
        <div className="hs-promo-track">
          {[...PROMO_ITEMS,...PROMO_ITEMS,...PROMO_ITEMS].map((item,i) => (
            <div className="hs-promo-item" key={i}>
              <span className="hs-promo-badge">{item.badge}</span>
              <span className="hs-promo-text">{item.text}</span>
              <div className="hs-promo-divider" />
            </div>
          ))}
        </div>
      </div>

      {/* ── HERO SLIDER ────────────────────────────────────────────────── */}
      <section className="hs-hero hs-hero--slider">

        {/* Slide 1 — existing "Powering Innovation" */}
        <div className={`hs-hero__slide ${heroSlide===0 ? 'hs-hero__slide--active' : ''} ${heroSlide===0 && heroAnim ? 'hs-hero__slide--exit' : ''}`}>
          <div className="hs-hero__image-bg">
            <img src={heroImage} alt="Hackathon Support" className="hs-hero__img" />
            <div className="hs-hero__overlay" />
          </div>
          <div className="hs-hero__content">
            <h1 className="hs-hero__title">Powering <span className="hs-hero__title--yellow">Innovation</span><br />at Every Hackathon</h1>
            <div className="hs-hero__tagline">
              <div className="hs-hero__tagline-bar" />
              <p>End-to-end support to organise, build and win hackathons — from idea to execution.</p>
            </div>
            <div className="hs-hero__features">
              <span>Hands-On Technical Experts</span><span className="hs-feat-divider">|</span>
              <span>Complete Event Support</span><span className="hs-feat-divider">|</span>
              <span>Real-Time Problem Solving</span><span className="hs-feat-divider">|</span>
              <span>Innovation Projects</span>
            </div>
            <div className="hs-hero__buttons">
              <button className="hs-btn hs-btn--primary" onClick={() => document.getElementById('hs-enquiry-section').scrollIntoView({ behavior:'smooth' })}>Get Support Now →</button>
              <button className="hs-btn hs-btn--secondary" onClick={() => document.getElementById('hs-services-section').scrollIntoView({ behavior:'smooth' })}>What We Offer ↓</button>
            </div>
            <div className="hs-hero__stats" ref={statsRef}>
              {STATS.map(s => <StatItem key={s.label} number={s.number} label={s.label} animate={animateStats} />)}
            </div>
          </div>
        </div>

        {/* Slide 2 — ibots Spark 1.0 */}
        <div className={`hs-hero__slide hs-hero__slide--spark ${heroSlide===1 ? 'hs-hero__slide--active' : ''} ${heroSlide===1 && heroAnim ? 'hs-hero__slide--exit' : ''}`}>
          <div className="hs-hero__image-bg">
            <img src="https://images.unsplash.com/photo-1581092921461-eab62e97a780?w=1600&q=80" alt="ibots Spark 1.0" className="hs-hero__img" />
            <div className="hs-hero__overlay hs-hero__overlay--spark" />
          </div>
          <div className="hs-hero__content hs-hero__content--spark">
            <div className="hs-spark-eyebrow">
              <span className="hs-spark-dot" />
              National School Hardware Hackathon Series
            </div>
            <h1 className="hs-hero__title">ibots <span className="hs-hero__title--yellow">Spark 1.0</span></h1>
            <div className="hs-hero__tagline">
              <div className="hs-hero__tagline-bar" />
              <p>India's premier school-level hardware hackathon — where young innovators build the future.</p>
            </div>
            <div className="hs-spark-cats-row">
              {[{ age:'8–10', label:'Category A', icon:'🌱' }, { age:'11–13', label:'Category B', icon:'⚡' }, { age:'14+', label:'Category C', icon:'🚀' }].map((c,i) => (
                <div key={i} className="hs-spark-cat-chip">
                  <span>{c.icon}</span>
                  <span className="hs-spark-cat-age">{c.age}</span>
                  <span className="hs-spark-cat-label">{c.label}</span>
                </div>
              ))}
            </div>
            <div className="hs-hero__buttons">
              <button className="hs-btn hs-btn--primary" onClick={() => navigate('/ibots-spark')}>Explore ibots Spark 1.0 →</button>
              <button className="hs-btn hs-btn--secondary" onClick={() => document.getElementById('hs-enquiry-section').scrollIntoView({ behavior:'smooth' })}>Register Interest</button>
            </div>
          </div>
        </div>

        {/* Slider controls */}
        <button className="hs-slider-arrow hs-slider-arrow--prev" onClick={() => goToSlide((heroSlide - 1 + HERO_SLIDES.length) % HERO_SLIDES.length)}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="15 18 9 12 15 6"/></svg>
        </button>
        <button className="hs-slider-arrow hs-slider-arrow--next" onClick={() => goToSlide((heroSlide + 1) % HERO_SLIDES.length)}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="9 18 15 12 9 6"/></svg>
        </button>

        {/* Dots */}
        <div className="hs-slider-dots">
          {HERO_SLIDES.map((_,i) => (
            <button key={i} className={`hs-slider-dot ${heroSlide===i ? 'hs-slider-dot--active' : ''}`} onClick={() => goToSlide(i)} />
          ))}
        </div>

        {/* Slide counter */}
        <div className="hs-slider-counter">{heroSlide + 1} / {HERO_SLIDES.length}</div>
      </section>

      {/* Services */}
      <section className="hs-services" id="hs-services-section">
        <div className="hs-services__header">
          <div className="hs-services__header-left">
            <div className="hs-services__label"><span className="hs-services__label-line" />OUR SERVICES</div>
            <h2 className="hs-services__title">What We Offer</h2>
            <p className="hs-services__subtitle">From planning to execution — ibots provides everything your institution needs to run a seamless, impactful hackathon.</p>
          </div>
          <button className="hs-services__cta" onClick={() => document.getElementById('hs-enquiry-section').scrollIntoView({ behavior:'smooth' })}>Get Support Now</button>
        </div>
        <div className="hs-services__grid">
          {SERVICES.map(service => (
            <div className="hs-service-card" key={service.number}>
              <div className="hs-service-card__image" style={{ backgroundImage:`url(${service.image})` }}>
                <div className="hs-service-card__img-overlay" />
                <div className="hs-service-card__img-content">
                  <span className="hs-service-card__number">{service.number} · SERVICE</span>
                  <div className="hs-service-card__icon">{service.icon}</div>
                  <h3 className="hs-service-card__name">{service.title}</h3>
                </div>
              </div>
              <div className="hs-service-card__body">
                <p className="hs-service-card__desc">{service.description}</p>
                <hr className="hs-service-card__divider" />
                <div className="hs-service-card__tags">
                  {service.tags.map(tag => <span className="hs-service-card__tag" key={tag}>{tag}</span>)}
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Video */}
      <section className="hs-video-section">
        <video ref={videoRef} className="hs-video-section__video" autoPlay muted loop playsInline
          onLoadedMetadata={() => { if (videoRef.current) videoRef.current.currentTime = 26; }}
          onTimeUpdate={() => { if (videoRef.current && videoRef.current.currentTime >= 33) videoRef.current.currentTime = 0; }}>
          <source src="https://ibots.in/wp-content/uploads/2026/04/karur-reels-hackathon.mp4" type="video/mp4" />
        </video>
        <div className="hs-video-section__overlay">
          <div className="hs-video-section__content">
            <span className="hs-video-section__tag">LIVE FROM THE GROUND</span>
            <h2 className="hs-video-section__title">See Us In Action</h2>
            <p className="hs-video-section__sub">Real hackathons. Real mentors. Real impact — across schools and colleges in Tamil Nadu.</p>
          </div>
        </div>
      </section>

      {/* Diff */}
      <section className="hs-diff">
        <div className="hs-diff__left">
          <div className="hs-diff__img-card" onClick={() => setExpandedVideo('https://ibots.in/wp-content/uploads/2026/04/karur-reels-hackathon.mp4')}>
            <video className="hs-diff__img" autoPlay muted loop playsInline onLoadedMetadata={e => { e.target.currentTime = 15; }}>
              <source src="https://ibots.in/wp-content/uploads/2026/04/karur-reels-hackathon.mp4" type="video/mp4" />
            </video>
            <div className="hs-diff__play-hint">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="white"><polygon points="5 3 19 12 5 21 5 3"/></svg>
              Tap to watch
            </div>
            <span className="hs-diff__img-label">IBOTS IN ACTION</span>
          </div>
        </div>
        {expandedVideo && (
          <div className="hs-video-modal" onClick={() => setExpandedVideo(null)}>
            <div className="hs-video-modal__box" onClick={e => e.stopPropagation()}>
              <button className="hs-video-modal__close" onClick={() => setExpandedVideo(null)}>✕</button>
              <video className="hs-video-modal__video" controls autoPlay playsInline onLoadedMetadata={e => { e.target.currentTime = 15; }}>
                <source src={expandedVideo} type="video/mp4" />
              </video>
            </div>
          </div>
        )}
        <div className="hs-diff__right">
          <div className="hs-diff__label"><span className="hs-diff__label-line" />WHY CHOOSE US</div>
          <h2 className="hs-diff__title">The ibots Difference</h2>
          <p className="hs-diff__subtitle">What sets ibots hackathon support apart from the rest.</p>
          <div className="hs-diff__items">
            {DIFFERENCES.map((item,i) => (
              <div className="hs-diff__item" key={i}>
                <div className="hs-diff__item-icon">{item.icon}</div>
                <div className="hs-diff__item-text">
                  <h4 className="hs-diff__item-title">{item.title}</h4>
                  <p className="hs-diff__item-desc">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="hs-stats-banner" ref={statsBannerRef}>
        {STATS_DATA.map((stat,i) => (
          <React.Fragment key={i}>
            <div className="hs-stats-banner__item">
              <span className="hs-stats-banner__number"><StatItem number={stat.number} animate={animateBanner} />{stat.suffix}</span>
              <span className="hs-stats-banner__label">{stat.label}</span>
            </div>
            {i < STATS_DATA.length - 1 && <div className="hs-stats-banner__divider" />}
          </React.Fragment>
        ))}
      </section>

      {/* Gallery */}
      <section className="hs-gallery">
        <div className="hs-gallery__header">
          <div className="hs-gallery__label"><span className="hs-gallery__label-line" />REAL MOMENTS</div>
          <h2 className="hs-gallery__title">Inside Our Hackathons</h2>
          <p className="hs-gallery__subtitle">Real innovation. Real impact. See how ibots brings hackathons to life.</p>
        </div>
        <div className="hs-gallery__grid">
          {GALLERY_IMAGES.map((src,i) => (
            <div className="hs-gallery__item" key={i}>
              <img src={src} alt={`Hackathon ${i+1}`} className="hs-gallery__img" />
              <div className="hs-gallery__img-overlay" />
            </div>
          ))}
        </div>
      </section>

      {/* ── BLINKING SPARK BANNER — above enquiry/CTA ────────────────────── */}
      <div className="hs-spark-blink-banner">
        <div className="hs-spark-blink-banner__pulse" />
        <div className="hs-spark-blink-banner__content">
          <span className="hs-spark-blink-banner__live">🔴 NOW OPEN</span>
          <span className="hs-spark-blink-banner__text">
            <strong>ibots Spark 1.0</strong> — National School Hardware Hackathon Series &nbsp;·&nbsp; Age Groups: 8–10 · 11–13 · 14+
          </span>
          <button className="hs-spark-blink-banner__btn" onClick={() => navigate('/ibots-spark')}>
            Explore & Register →
          </button>
        </div>
      </div>

      <hr className="hs-divider" />

      {/* Enquiry */}
      <section className="hs-enquiry" id="hs-enquiry-section">
        <div className="hs-enquiry__left">
          <div className="hs-enquiry__label"><span className="hs-enquiry__label-line" />GET IN TOUCH</div>
          <h2 className="hs-enquiry__title">Let's Plan Your Hackathon</h2>
          <p className="hs-enquiry__subtitle">Share your requirements and our team will get in touch to help you organise a seamless and impactful hackathon.</p>
          <div className="hs-enquiry__form">
            <h4 className="hs-enquiry__form-title">Enquiry Form</h4>
            {hsSubmitted ? (
              <div style={{ display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', minHeight:'300px', textAlign:'center', gap:'16px' }}>
                <div style={{ width:'64px', height:'64px', borderRadius:'50%', background:'#dcfce7', color:'#16a34a', fontSize:'28px', display:'flex', alignItems:'center', justifyContent:'center', fontWeight:900 }}>✓</div>
                <h2 style={{ color:'#0d2e6e', fontWeight:900, margin:0 }}>Thank You for Reaching Out to ibots!</h2>
                <p style={{ color:'#64748b', margin:0, maxWidth:'300px', lineHeight:'1.6' }}>We have received your enquiry and will be in touch shortly.</p>
              </div>
            ) : (
              <>
                <div className="hs-enquiry__row">
                  <div className="hs-enquiry__field"><label>Name *</label><input type="text" placeholder="Your full name" value={hsForm.name} onChange={e => { setHsForm({...hsForm, name:e.target.value}); setErrors({...errors, name:''}); }}/>{errors.name && <p style={errStyle} className="error-field">{errors.name}</p>}</div>
                  <div className="hs-enquiry__field"><label>Mobile Number *</label><input type="tel" placeholder="+91 XXXXX XXXXX" value={hsForm.phone} onChange={e => { setHsForm({...hsForm, phone:e.target.value}); setErrors({...errors, phone:''}); }}/>{errors.phone && <p style={errStyle} className="error-field">{errors.phone}</p>}</div>
                </div>
                <div className="hs-enquiry__row">
                  <div className="hs-enquiry__field"><label>Email Address *</label><input type="email" placeholder="you@institution.edu.in" value={hsForm.email} onChange={e => { setHsForm({...hsForm, email:e.target.value}); setErrors({...errors, email:''}); }}/>{errors.email && <p style={errStyle} className="error-field">{errors.email}</p>}</div>
                  <div className="hs-enquiry__field"><label>Organization / Institution *</label><input type="text" placeholder="College / School name" value={hsForm.organization} onChange={e => { setHsForm({...hsForm, organization:e.target.value}); setErrors({...errors, organization:''}); }}/>{errors.organization && <p style={errStyle} className="error-field">{errors.organization}</p>}</div>
                </div>
                <div className="hs-enquiry__row">
                  <div className="hs-enquiry__field"><label>Location *</label><input type="text" placeholder="City, Tamil Nadu" value={hsForm.location} onChange={e => { setHsForm({...hsForm, location:e.target.value}); setErrors({...errors, location:''}); }}/>{errors.location && <p style={errStyle}>{errors.location}</p>}</div>
                  <div className="hs-enquiry__field"><label>Expected Hackathon Date</label><input type="date" value={hsForm.hackathonDate} onChange={e => setHsForm({...hsForm, hackathonDate:e.target.value})}/></div>
                </div>
                <div className="hs-enquiry__field hs-enquiry__field--full"><label>Services Required</label><select value={hsForm.servicesRequired} onChange={e => setHsForm({...hsForm, servicesRequired:e.target.value})}><option value="">Select a service...</option><option>End-to-End Organization</option><option>Movable Store Support</option><option>Technical Mentorship</option><option>Sponsorship Management</option><option>All Services</option></select></div>
                <div className="hs-enquiry__field hs-enquiry__field--full"><label>Message (Optional)</label><textarea placeholder="Describe your hackathon theme, expected participants, duration, special requirements..." value={hsForm.message} onChange={e => setHsForm({...hsForm, message:e.target.value})} rows={4}/></div>
                <div className="hs-enquiry__field hs-enquiry__field--full"><label>How did you hear about ibots? *</label><select value={hsForm.source} onChange={e => { setHsForm({...hsForm, source:e.target.value}); setErrors({...errors, source:''}); }}><option value="">Select...</option>{SOURCE_OPTIONS.map(s => <option key={s} value={s}>{s}</option>)}</select>{errors.source && <p style={errStyle}>{errors.source}</p>}{hsForm.source==='Other' && <input type="text" placeholder="Please tell us how you found us..." value={hsForm.customSource} onChange={e => setHsForm({...hsForm, customSource:e.target.value})} style={{ marginTop:'8px' }}/>}</div>
                <button className="hs-enquiry__submit" onClick={handleHsSubmit}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>
                  Submit Enquiry
                </button>
              </>
            )}
          </div>
        </div>
        <div className="hs-enquiry__right">
          <img src="https://ibots.in/wp-content/uploads/2026/03/391x574-image-design-website-low-697x1024.png" alt="ibots Hackathon Support" className="hs-enquiry__img" />
        </div>
      </section>
      <hr className="hs-divider" />
      <OurOffices />
      <Footer ctaHeading={"Have Questions About Our\nHackathon Support?"} ctaSub={"Feel free to reach out to us for any queries or guidance.\nOur team is here to help you plan the right hackathon."} />
    </div>
  );
}

export default HackathonSupport;
// file already created above
